<template>
  <div class="cooper">
    <div class="contain">
      <div class="img-box  double-center">
        <img
          class="ljb-logo"
          src="https://cdn.51ljb.cn/ljb-logo_czh.png">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CooperationLogo',
  data () {
    return {}
  },
  mounted () {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.cooper{
  background: #fff;
  margin-top: 1px;
  padding: 25px 50px;
  .contain{
    position: relative;
    border-top:1px solid $border-color;
    text-align: center;
    padding: 0 $padding;
  }
  .img-box{
    background: #fff;
    position: absolute;
    top:-10px;
    left: 50%;
    transform: translate(-50%, -0%);
  }
  .ljb-logo{
    width: 150px;
    height: 25px;
    margin:0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/CooperationLogo.vue